import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectIsMapVisible } from '@immosky/object-search-layout';
import { AppState, FilterState } from '@immosky/types';
import { DesktopFilterService } from '../../../services/desktop-filter.service';
import { Subscription } from 'rxjs';
import { selectFilterState } from '@immosky/object-search-filter';
import { DesktopFiltersLayoutRenderer } from './desktop-filters-layout-renderer';

@Component({
  selector: 'app-desktop-filters',
  templateUrl: './desktop-filters.component.html',
  styleUrls: ['./desktop-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopFiltersComponent implements AfterViewInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  isMapVisible$ = this.store.pipe(select(selectIsMapVisible));

  @ViewChild('container')
  container!: ElementRef<HTMLElement>;

  @ViewChild('dropdownContainer')
  dropdownContainer!: ElementRef<HTMLElement>;

  @ViewChild('additionalFiltersContainer')
  additionalFiltersContainer!: ElementRef<HTMLElement>;

  @ViewChildren('dropdown')
  dropdownQueryList!: QueryList<ElementRef<HTMLElement>>;

  layoutRenderer!: DesktopFiltersLayoutRenderer;

  displayRoomCount = false;
  displayLivingSpace = false;
  displayUsageSpace = false;
  displayPropertySpace = false;

  constructor(
    private store: Store<AppState>,
    private desktopFilterService: DesktopFilterService
  ) {
    const filterStateSubscription = this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.displayRoomCount = filterState.roomCount.isDisplayed;
        this.displayLivingSpace = filterState.livingSpace.isDisplayed;
        this.displayUsageSpace = filterState.usageSpace.isDisplayed;
        this.displayPropertySpace = filterState.propertySpace.isDisplayed;
      });
    this.subscriptions.push(filterStateSubscription);
  }

  ngAfterViewInit(): void {
    this.layoutRenderer = new DesktopFiltersLayoutRenderer(
      this.desktopFilterService,
      this.container.nativeElement,
      this.additionalFiltersContainer.nativeElement
    );

    this.dropdownQueryList.changes.subscribe((queryList) => {
      this.updateDropdownElements(queryList);
    });
    this.updateDropdownElements(this.dropdownQueryList);

    this.layoutRenderer.start();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.layoutRenderer.destroy();
  }

  private updateDropdownElements(
    queryList: QueryList<ElementRef<HTMLElement>>
  ) {
    const dropdownElements = queryList.toArray().map((ref) => {
      return ref.nativeElement;
    });
    this.layoutRenderer.setDropdownElements(dropdownElements);
  }
}
